import { formatCurrencyBRL, parseCurrency } from '@utils/currency.util';

import { env } from 'src/app/env';

export function linkToOfferScreen(
  offerId: number | string,
  productId: number | string,
  type: 'edit' | 'view' | 'duplicate' = 'edit'
) {
  return `/products/${productId}/offers/${offerId}?type=${type}`;
}

export function buildOfferCheckoutLink(
  productId: number | string | undefined,
  offerId: number | string | undefined
) {
  return `${buildProductCheckoutLink(productId)}?offerId=${offerId}`;
}

export function buildProductCheckoutLink(productId: number | string | undefined) {
  return `${env.CHECKOUT}${productId}`;
}

export function generateInstallments(fullPrice = '') {
  const parsedFullPrice = parseCurrency(fullPrice);
  const hasInstallmentPrice = !!parsedFullPrice && parsedFullPrice > 0;
  const objects = [];
  for (let i = 1; i <= 12; i++) {
    const object = {
      value: i.toString(),
      label: hasInstallmentPrice
        ? `${i.toString()}x de R$ ${formatCurrencyBRL(parsedFullPrice / i)}`
        : `${i.toString()}x`,
    };
    objects.push(object);
  }
  return objects;
}
